import React, { FC, useState } from "react";
import "../../Sidebar/Sidebar.scss";
import { ReactSVG } from 'react-svg';
import logo from '../../../Assets/icons/logo.svg';
import logoSmall from '../../../Assets/icons/logo-small.svg';
import { useSelector} from 'react-redux';
import { selectConfig, selectResellerConfig } from '../../../Store/configSlice';
import { selectUserId } from "../../../Store/adminSlice";
import VideoTutorial from "../../Tutorials/VideoTutorial";
import Button, { EButtonSize, EButtonType } from "../../Buttons/Button";
import CaretLeftIcon from "../../../Assets/icons/caret-left.svg";
import { useTranslation } from "react-i18next";

interface IResellerSidebarProps {
  resellerLogo?: string,
  resellerLogoSmall?: string
}

const ResellerSidebar: FC<IResellerSidebarProps> = ({ resellerLogo, resellerLogoSmall }) => {
    const userId = useSelector(selectUserId);

    const [ open, setOpen ] = useState(true);

    const config = useSelector(selectConfig);
    const resellerConfig = useSelector(selectResellerConfig);

    const { t } = useTranslation();

    const onBackClick = () => {
      window.location.href = resellerConfig.returnUrl || "https://www.legalfly.ai" 
    }

    return (
        <div className={"sidebar " + (open ? "open" : "closed")}>
            <div className="sidebar-wrapper">
                <div className="hamburger" onClick={() => setOpen(!open)} data-click-target={!open ? "close" : "open"} data-click-source="sidebar"></div>
                {resellerLogo && <div className="logo reseller">
                    <img src={resellerLogo} alt="logo" />
                </div>}
                {resellerLogoSmall && <div className="logo-small reseller">
                    <img src={resellerLogoSmall} alt="logo" />
                </div>}
                <div className="logo-small">
                    <ReactSVG src={logoSmall} />
                </div>
                <div className="logo powered-by">
                    <span>Powered by</span><ReactSVG src={logo} />
                </div>
                <div className="menu">
                  <div style={{ marginTop: "16px" }} />
                  <Button
                    buttonType={EButtonType.SECONDARY}
                    size={EButtonSize.SMALL}
                    text={t("reseller.back")}
                    onClick={onBackClick}
                    iconLeft={CaretLeftIcon}
                    iconSize={16}
                  />
                </div>
                <VideoTutorial />
                { userId && <div className="admin-notice">
                    Viewing LegalFly as <b>{userId}</b>
                    <div className="button" onClick={() => {window.location.reload()}}>Stop</div>
                </div> }
            </div>
        </div>
    );
};

export default ResellerSidebar;
